/*
  Chefs Evolution – prima pagină.
  - „+” pe produs: adaugă în coș fără să părăsești pagina (cu cantitatea minimă a produsului, dacă are);
    la produsele cu mărimi deschide alegerea mărimii;
  - confirmarea de jos: produsul adăugat și cât mai e până la cadou (pragurile din adminul clienti);
  - săgețile rafturilor pe calculator;
  - bara de secțiuni: butoane care duc la raftul respectiv, în aceeași pagină;
  - bannerele de sus (trec singure) și „Citește tot” la textul despre noi.
*/
(function () {
  'use strict';
  if (window.__ceAcasa) return;
  window.__ceAcasa = true;

  var RAD = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var API = 'https://clienti.mancaregatita.ro';
  var cadou = null;        // pragurile, încărcate o singură dată
  var reguli = {};         // cantitățile minime pe produs
  var formatBani = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function json(url, opt) { return fetch(url, opt).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  function bani(centi) {
    var v = ((Number(centi) || 0) / 100).toFixed(2);
    var p = v.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (formatBani || '{' + '{amount}} lei').replace(/\{\{\s*\w+\s*\}\}/, p.join('.')).replace(/<[^>]*>/g, '');
  }
  function lat(img, w) { if (!img) return ''; return img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }

  // ---------- antetul lipit sus: bara de secțiuni stă imediat sub el ----------
  function masoaraAntet() {
    var h = document.querySelector('.t4s-section-header');
    var sus = 0;
    if (h) {
      var cs = getComputedStyle(h);
      if (cs.position === 'sticky' || cs.position === 'fixed') sus = Math.round(h.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty('--ce-sus', sus + 'px');
  }

  // ---------- cantitatea minimă (aceleași reguli ca în coș) ----------
  // textele regulilor (ex. „Se comandă cu cel puțin 6 ore înainte de livrare.”), pentru mesajul „… e în coș”
  var texteReguli = {};
  function minim(produs) {
    if (produs in reguli) return Promise.resolve(reguli[produs]);
    return json(API + '/api/reguli?produse=' + produs).then(function (d) {
      var x = d.reguli && d.reguli[produs];
      reguli[produs] = x ? Math.max(1, Number(x.minim) || 1) : 1;
      texteReguli[produs] = x && Array.isArray(x.texte) ? x.texte : [];
      return reguli[produs];
    }).catch(function () { reguli[produs] = 1; texteReguli[produs] = []; return 1; });
  }

  // ---------- cadoul: cât mai e până la următorul prag ----------
  function incarcaCadou() {
    if (cadou) return Promise.resolve(cadou);
    return json(API + '/api/cadou').then(function (c) {
      cadou = c && c.activ && Array.isArray(c.praguri) ? c.praguri.filter(function (p) { return p.produse && p.produse.length; }).sort(function (a, b) { return a.prag - b.prag; }) : [];
      return cadou;
    }).catch(function () { cadou = []; return cadou; });
  }
  function mesajCadou(cos) {
    var sub = cos.items.reduce(function (s, it) { return it.properties && it.properties._cadou ? s : s + it.original_line_price; }, 0);
    var urm = (cadou || []).filter(function (p) { return sub < Math.round(p.prag * 100); })[0];
    var atinse = (cadou || []).filter(function (p) { return sub >= Math.round(p.prag * 100); });
    if (urm) return { text: 'Mai adaugă ' + bani(Math.round(urm.prag * 100) - sub) + ' și primești ' + urm.produse[0].titlu + ' cadou', proc: Math.min(100, sub / Math.round(urm.prag * 100) * 100) };
    if (atinse.length) return { text: 'Ai ajuns la ' + bani(Math.round(atinse[atinse.length - 1].prag * 100)) + ': alege cadoul în coș', proc: 100 };
    return null;
  }

  // ---------- confirmarea de jos ----------
  var toast = null, temporizare = null;
  function arata(html, eroare, durata) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ce-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.classList.toggle('ce-toast--eroare', Boolean(eroare));
    toast.innerHTML = html;
    requestAnimationFrame(function () { toast.classList.add('is-vizibil'); });
    clearTimeout(temporizare);
    temporizare = setTimeout(function () { toast.classList.remove('is-vizibil'); }, durata || 6000);
  }

  function actualizeazaAntet(cos) {
    document.querySelectorAll('[data-cart-count]').forEach(function (x) { x.textContent = cos.item_count; });
    document.querySelectorAll('[data-cart-tt-price]').forEach(function (x) { x.textContent = bani(cos.total_price); });
  }

  // confirmarea „… e în coș” (în locul coșului lateral, care e oprit): cu bara până la cadou și „Vezi coșul”
  function confirmare(cos, titlu, cantitate, imagine, texte) {
    var m = mesajCadou(cos);
    // regulile produsului (ore înainte, cantitate minimă…), ca clientul să le vadă imediat
    var reg = texte && texte.length ? '<span class="ce-toast__reguli">' + texte.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') + '</span>' : '';
    arata((imagine ? '<img src="' + esc(lat(imagine, 120)) + '" alt="">' : '<span></span>') +
      '<div><b>' + esc(titlu) + (cantitate > 1 ? ' (' + cantitate + ' buc.)' : '') + ' e în coș</b>' + reg +
      (m ? '<small>' + esc(m.text) + '</small><div class="ce-toast__bara"><i style="width:' + m.proc.toFixed(0) + '%"></i></div>' : '') +
      '</div><a href="' + RAD + 'cart">Vezi coșul</a>', false, reg ? 10000 : 6000);
  }

  // produsele adăugate din altă parte (butonul „Adaugă în coș” al paginii de produs, aplicații):
  // aceeași confirmare. Se urmăresc doar cererile POST către /cart/add; răspunsul nu se modifică.
  function urmaresteAdaugari() {
    var original = window.fetch;
    if (!original || original.__ceUrmarit) return;
    var nou = function (intrare, optiuni) {
      var raspuns = original.apply(this, arguments);
      try {
        var url = typeof intrare === 'string' ? intrare : (intrare && intrare.url) || '';
        var metoda = String((optiuni && optiuni.method) || (intrare && intrare.method) || 'GET').toUpperCase();
        var antete = (optiuni && optiuni.headers) || {};
        var alNostru = antete['X-Ce-Adauga'] || (typeof antete.get === 'function' && antete.get('X-Ce-Adauga'));
        if (metoda === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && !alNostru && !/\/cart\/?$/.test(location.pathname)) {
          raspuns.then(function (r) {
            if (!r.ok) return;
            r.clone().json().then(function (j) {
              var linie = j && (Array.isArray(j.items) ? j.items[0] : j);
              if (!linie || !linie.product_title) return;
              var pid = linie.product_id ? String(linie.product_id) : '';
              Promise.all([json(RAD + 'cart.js'), incarcaCadou(), pid ? minim(pid) : null]).then(function (x) {
                actualizeazaAntet(x[0]);
                confirmare(x[0], linie.product_title, linie.quantity || 1, linie.featured_image ? linie.featured_image.url : linie.image, pid ? texteReguli[pid] : null);
              }).catch(function () {});
            }).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) { /* nu stricăm cererea */ }
      return raspuns;
    };
    nou.__ceUrmarit = true;
    window.fetch = nou;
  }
  urmaresteAdaugari();

  function adauga(varianta, cantitate, titlu, imagine, buton, produs) {
    if (buton) { buton.disabled = true; buton.classList.add('is-lucreaza'); }
    return fetch(RAD + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Ce-Adauga': '1' },
      body: JSON.stringify({ items: [{ id: Number(varianta), quantity: cantitate }] }),
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      return Promise.all([json(RAD + 'cart.js'), incarcaCadou()]);
    }).then(function (r) {
      var cos = r[0];
      actualizeazaAntet(cos);
      confirmare(cos, titlu, cantitate, imagine, produs ? texteReguli[produs] : null);
      if (buton) {
        buton.classList.remove('is-lucreaza');
        buton.classList.add('is-adaugat');
        var bifa = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        if (buton.hasAttribute('data-ce-lat')) {
          // butonul lat din vitrină: bifă + „În coș”, apoi revine la textul lui
          if (!buton.hasAttribute('data-ce-text')) buton.setAttribute('data-ce-text', buton.innerHTML);
          buton.innerHTML = bifa + '<span>În coș</span>';
          setTimeout(function () { buton.innerHTML = buton.getAttribute('data-ce-text'); buton.classList.remove('is-adaugat'); }, 2500);
        } else {
          buton.innerHTML = bifa;
          buton.setAttribute('aria-label', titlu + ' e în coș. Apasă ca să mai adaugi.');
        }
        setTimeout(function () { buton.disabled = false; }, 600);
      }
    }).catch(function (e) {
      if (buton) { buton.disabled = false; buton.classList.remove('is-lucreaza'); }
      arata('<div><b>Nu am putut adăuga produsul</b><small>' + esc((e && (e.description || e.message)) || 'Încearcă din nou sau deschide pagina produsului.') + '</small></div>', true);
    });
  }

  // ---------- alegerea mărimii ----------
  var foaie = null, fundal = null, ultimulFocus = null;
  function inchideFoaia() {
    if (!foaie) return;
    foaie.classList.remove('is-deschis'); fundal.classList.remove('is-deschis');
    var f = foaie, g = fundal; foaie = null; fundal = null;
    setTimeout(function () { f.remove(); g.remove(); }, 200);
    document.removeEventListener('keydown', taste);
    if (ultimulFocus) ultimulFocus.focus();
  }
  function taste(e) { if (e.key === 'Escape') inchideFoaia(); }
  function deschideFoaia(date, produs, buton) {
    ultimulFocus = buton;
    if (toast) toast.classList.remove('is-vizibil');
    var disponibile = date.variante.filter(function (v) { return v.disponibil; });
    var ales = disponibile[0];
    fundal = document.createElement('div'); fundal.className = 'ce-foaie-fundal';
    foaie = document.createElement('div'); foaie.className = 'ce-foaie';
    foaie.setAttribute('role', 'dialog'); foaie.setAttribute('aria-modal', 'true'); foaie.setAttribute('aria-label', 'Alege mărimea pentru ' + date.titlu);
    var h = '<div class="ce-foaie__sus">' + (date.imagine ? '<img src="' + esc(date.imagine) + '" alt="">' : '<span></span>') +
      '<div><h4>' + esc(date.titlu) + '</h4><p>Alege cât vrei</p></div><button type="button" class="ce-foaie__inchide" data-ce-inchide aria-label="Închide">×</button></div><div class="ce-foaie__marimi">';
    date.variante.forEach(function (v) {
      h += '<button type="button" data-ce-marime="' + v.id + '" aria-pressed="' + (ales && v.id === ales.id) + '"' + (v.disponibil ? '' : ' disabled') + '><b>' + esc(v.titlu) + '</b>' + esc(v.pret) + '</button>';
    });
    h += '</div><button type="button" class="ce-foaie__adauga" data-ce-adauga-marime>Adaugă în coș</button>';
    foaie.innerHTML = h;
    document.body.appendChild(fundal); document.body.appendChild(foaie);
    requestAnimationFrame(function () { foaie.classList.add('is-deschis'); fundal.classList.add('is-deschis'); });
    fundal.addEventListener('click', inchideFoaia);
    document.addEventListener('keydown', taste);
    foaie.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-ce-inchide')) { inchideFoaia(); return; }
      if (b.hasAttribute('data-ce-marime')) {
        ales = date.variante.filter(function (v) { return String(v.id) === b.getAttribute('data-ce-marime'); })[0];
        foaie.querySelectorAll('[data-ce-marime]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        return;
      }
      if (b.hasAttribute('data-ce-adauga-marime') && ales) {
        b.disabled = true;
        minim(produs).then(function (n) {
          var titlu = date.titlu + ', ' + ales.titlu;
          inchideFoaia();
          adauga(ales.id, n, titlu, date.imagine, buton, produs);
        });
      }
    });
    var primul = foaie.querySelector('[aria-pressed="true"]') || foaie.querySelector('[data-ce-adauga-marime]');
    if (primul) primul.focus();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ce-plus]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('[data-ce-card]');
    var produs = card.getAttribute('data-produs');
    var titlu = (card.querySelector('.ce-card__nume') || {}).textContent || '';
    var img = card.querySelector('.ce-card__img');
    var imagine = img ? (img.currentSrc || img.src).split('?')[0] : '';
    if (b.getAttribute('data-mod') === 'marime') {
      var s = card.querySelector('[data-ce-variante]');
      var date = null;
      try { date = JSON.parse(s.textContent); } catch (err) { date = null; }
      if (date && date.variante && date.variante.length) { deschideFoaia(date, produs, b); return; }
    }
    minim(produs).then(function (n) { adauga(b.getAttribute('data-varianta'), n, titlu.trim(), imagine, b, produs); });
  });

  // ---------- săgețile rafturilor ----------
  function pregatesteRaft(raft) {
    var lista = raft.querySelector('[data-ce-produse]');
    var inapoi = raft.querySelector('[data-ce-inapoi]');
    var inainte = raft.querySelector('[data-ce-inainte]');
    if (!lista || !inapoi || !inainte) return;
    // apelat a doua oară (raft completat după încărcare): doar se recalculează săgețile
    if (raft.__ceStareRaft) { raft.__ceStareRaft(); return; }
    function stare() {
      var max = lista.scrollWidth - lista.clientWidth;
      var areDerulare = max > 4;
      inapoi.hidden = inainte.hidden = !areDerulare;
      inapoi.disabled = lista.scrollLeft <= 2;
      inainte.disabled = lista.scrollLeft >= max - 2;
    }
    function muta(dir) { lista.scrollBy({ left: dir * lista.clientWidth, behavior: 'smooth' }); }
    inapoi.addEventListener('click', function () { muta(-1); });
    inainte.addEventListener('click', function () { muta(1); });
    lista.addEventListener('scroll', function () { requestAnimationFrame(stare); }, { passive: true });
    window.addEventListener('resize', stare);
    raft.__ceStareRaft = stare;
    stare();
  }

  // rafturile încărcate după pagină (recomandările de pe pagina de produs) își pornesc săgețile de aici
  window.cePregatesteRaft = pregatesteRaft;

  // ---------- bara de secțiuni ----------
  function pregatesteIndex() {
    var cutie = document.querySelector('[data-ce-index]');
    var nav = document.querySelector('[data-ce-index-nav]');
    if (!cutie || !nav) return;
    var rafturi = Array.prototype.slice.call(document.querySelectorAll('[data-ce-raft]')).filter(function (r) { return r.getAttribute('data-eticheta'); });
    if (rafturi.length < 2) return;
    nav.innerHTML = rafturi.map(function (r) { return '<button type="button" data-ce-la="' + r.id + '">' + esc(r.getAttribute('data-eticheta')) + '</button>'; }).join('');
    cutie.hidden = false;
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ce-la]');
      if (!b) return;
      var t = document.getElementById(b.getAttribute('data-ce-la'));
      if (t) t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    if ('IntersectionObserver' in window) {
      var vizibile = {};
      var obs = new IntersectionObserver(function (intrari) {
        intrari.forEach(function (x) { vizibile[x.target.id] = x.isIntersecting; });
        var activ = rafturi.filter(function (r) { return vizibile[r.id]; })[0];
        if (!activ) {
          // deasupra primului raft: niciun buton activ
          var primul = rafturi[0].getBoundingClientRect().top;
          if (primul > window.innerHeight * 0.35) nav.querySelectorAll('[data-ce-la]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          return;
        }
        nav.querySelectorAll('[data-ce-la]').forEach(function (b) {
          var e = b.getAttribute('data-ce-la') === activ.id;
          b.setAttribute('aria-current', String(e));
          if (e && nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: b.offsetLeft - 16, behavior: 'smooth' });
        });
      }, { rootMargin: '-35% 0px -55% 0px' });
      rafturi.forEach(function (r) { obs.observe(r); });
    }
  }

  // ---------- bannerele de sus ----------
  function pregatesteErou(erou) {
    var sina = erou.querySelector('[data-ce-erou-sina]');
    if (!sina) return;
    // listele se citesc mereu din pagină: bannerul cadou poate dispărea după încărcare
    function slideuri() { return Array.prototype.slice.call(erou.querySelectorAll('[data-ce-erou-slide]')); }
    function puncte() { return Array.prototype.slice.call(erou.querySelectorAll('[data-ce-erou-la]')); }
    var timp = Math.max(3, Number(erou.getAttribute('data-timp')) || 7) * 1000;
    var linistit = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var curent = 0, ceas = null, oprit = false;
    erou.style.setProperty('--ce-timp', (timp / 1000) + 's');
    if (linistit) erou.classList.add('is-static');

    function prea_putine() { return slideuri().length < 2; }
    function marcheaza(i) {
      var p = puncte();
      if (i === curent && p[i] && p[i].getAttribute('aria-current') === 'true') return;
      curent = i;
      p.forEach(function (x, j) {
        if (j === i) {
          x.setAttribute('aria-current', 'true');
          // repornește bara de progres
          var bara = x.querySelector('i');
          if (bara) { bara.style.display = 'none'; void bara.offsetWidth; bara.style.display = ''; }
        } else x.removeAttribute('aria-current');
      });
    }
    function du(i) {
      var s = slideuri(), n = s.length;
      if (!n) return;
      i = (i + n) % n;
      sina.scrollTo({ left: s[i].offsetLeft, behavior: linistit ? 'auto' : 'smooth' });
      marcheaza(i);
      porneste();
    }
    function porneste() {
      clearTimeout(ceas);
      if (linistit || oprit || document.hidden || prea_putine()) return;
      ceas = setTimeout(function () { du(curent + 1); }, timp);
    }
    function opreste(da) { oprit = da; erou.classList.toggle('is-oprit', da); if (da) clearTimeout(ceas); else porneste(); }

    // scoate un banner (bannerul cadou fără cadouri active) și renumerotează punctele
    erou.__ceScoateSlide = function (slide) {
      var s = slideuri(), k = s.indexOf(slide);
      if (k < 0) return;
      var p = puncte();
      slide.parentNode.removeChild(slide);
      if (p[k]) p[k].parentNode.removeChild(p[k]);
      var n = s.length - 1;
      slideuri().forEach(function (x, j) { x.setAttribute('aria-label', (j + 1) + ' din ' + n); });
      puncte().forEach(function (x, j) { x.setAttribute('data-ce-erou-la', j); x.setAttribute('aria-label', 'Bannerul ' + (j + 1)); });
      if (n < 2) {
        erou.classList.add('is-static');
        erou.querySelectorAll('[data-ce-erou-inapoi],[data-ce-erou-inainte],[data-ce-erou-puncte]').forEach(function (x) { x.hidden = true; });
        clearTimeout(ceas);
      }
      if (curent >= n) curent = 0;
      var actual = slideuri()[curent];
      if (actual) sina.scrollTo({ left: actual.offsetLeft, behavior: 'auto' });
      marcheaza(curent); porneste();
    };

    if (prea_putine()) { erou.classList.add('is-static'); return; }
    var inapoi = erou.querySelector('[data-ce-erou-inapoi]');
    var inainte = erou.querySelector('[data-ce-erou-inainte]');
    if (inapoi) inapoi.addEventListener('click', function () { du(curent - 1); });
    if (inainte) inainte.addEventListener('click', function () { du(curent + 1); });
    var cutiePuncte = erou.querySelector('[data-ce-erou-puncte]');
    if (cutiePuncte) cutiePuncte.addEventListener('click', function (e) {
      var x = e.target.closest('[data-ce-erou-la]');
      if (x) du(Number(x.getAttribute('data-ce-erou-la')));
    });

    // derulare cu degetul: punctul urmează bannerul vizibil
    var t = null;
    sina.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(sina.scrollLeft / Math.max(1, sina.clientWidth));
        if (i !== curent) { marcheaza(Math.min(slideuri().length - 1, Math.max(0, i))); porneste(); }
      }, 120);
    }, { passive: true });

    erou.addEventListener('mouseenter', function () { opreste(true); });
    erou.addEventListener('mouseleave', function () { opreste(false); });
    erou.addEventListener('focusin', function () { opreste(true); });
    erou.addEventListener('focusout', function (e) { if (!erou.contains(e.relatedTarget)) opreste(false); });
    sina.addEventListener('touchstart', function () { clearTimeout(ceas); }, { passive: true });
    sina.addEventListener('touchend', function () { porneste(); }, { passive: true });
    document.addEventListener('visibilitychange', porneste);
    window.addEventListener('resize', function () { var s = slideuri()[curent]; if (s) sina.scrollTo({ left: s.offsetLeft, behavior: 'auto' }); });
    porneste();
  }

  // ---------- bannerul cadou (automat, din adminul clienti.mancaregatita.ro) ----------
  function banLei(x) { var n = Number(x); return isFinite(n) ? (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0) + ' lei' : ''; }
  function imagineMica(url, w) {
    if (!url) return '';
    if (/(^|\.)cdn\.shopify\.com\/|\/cdn\/shop\//.test(url)) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    // imaginile din adminul de cadouri (Supabase Storage) au transformare de imagine activă:
    // /object/public/... -> /render/image/public/...?width=W
    if (/\/storage\/v1\/object\/public\//.test(url)) {
      var t = url.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/');
      // atenție: Supabase NU păstrează automat proporțiile dacă primește doar „width” –
      // păstrează înălțimea originală, ceea ce deformează imaginea. Trimitem și „height”,
      // cu resize=contain, ca imaginea să fie încadrată proporțional, nu deformată/decupată.
      return t + (t.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&height=' + w + '&resize=contain&quality=80';
    }
    return url;
  }
  var SAGEATA_CB = '<svg class="ce-cb__sageata" viewBox="0 0 60 30" aria-hidden="true"><path d="M3 22c14-9 30-12 47-9" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round"/><path d="M40 4l13 9-12 10" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function pregatesteCadouBanner(slide) {
    var erou = slide.closest('[data-ce-erou]');
    var cutie = slide.querySelector('[data-ce-cb]');
    var dr = slide.querySelector('[data-ce-cb-praguri]');
    if (!cutie || !dr) return;
    function scoate(eroare) {
      if (slide.hasAttribute('data-editor')) {
        cutie.classList.remove('is-incarca');
        dr.innerHTML = '<span class="ce-cb__card ce-cb__card--2"><span class="ce-cb__card-text" style="width:100%"><span class="ce-cb__produs">' +
          (eroare ? 'Cadourile nu se pot citi în previzualizare; pe site se completează din admin.' : 'În admin nu e niciun cadou activ – pe site bannerul nu apare.') + '</span></span></span>';
        return;
      }
      if (erou && erou.__ceScoateSlide) erou.__ceScoateSlide(slide); else slide.parentNode.removeChild(slide);
    }
    function suma(x) { var n = Number(x); return isFinite(n) ? (n % 1 ? n.toFixed(2) : String(n)) : esc(x); }
    function poza(x) {
      // poza decupată încărcată în adminul de cadouri are prioritate
      if (x.imagineBanner) return '<span class="ce-cb__poza is-decupat"><img src="' + esc(imagineMica(x.imagineBanner, 400)) + '" srcset="' +
        esc(imagineMica(x.imagineBanner, 240)) + ' 240w, ' + esc(imagineMica(x.imagineBanner, 400)) + ' 400w, ' + esc(imagineMica(x.imagineBanner, 600)) + ' 600w" sizes="(max-width: 767px) 34vw, 200px" alt="" width="400" height="400" loading="eager"></span>';
      if (!x.imagine) return '';
      return '<span class="ce-cb__poza" data-handle="' + esc(x.handle || '') + '"><img src="' + esc(imagineMica(x.imagine, 400)) + '" srcset="' +
        esc(imagineMica(x.imagine, 240)) + ' 240w, ' + esc(imagineMica(x.imagine, 400)) + ' 400w, ' + esc(imagineMica(x.imagine, 600)) + ' 600w" sizes="(max-width: 767px) 34vw, 200px" alt="" width="400" height="400" loading="eager"></span>';
    }
    // dacă produsul-cadou are o imagine cu textul alternativ „decupat” (PNG fără fundal), o folosim pe aceea
    function cautaDecupate() {
      var rad = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Array.prototype.slice.call(dr.querySelectorAll('.ce-cb__poza[data-handle]')).forEach(function (el) {
        var h = el.getAttribute('data-handle');
        if (!h) return;
        fetch(rad + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) return;
          var m = (p.media || []).filter(function (x) { return x.media_type === 'image' && (/decupat|cutout|transparent/i.test(x.alt || '') || /decupat/i.test(x.src || '')); })[0];
          var src = m && (m.src || (m.preview_image && m.preview_image.src));
          if (!src) return;
          var img = new Image();
          img.onload = function () {
            var vechi = el.querySelector('img');
            vechi.removeAttribute('srcset');
            vechi.src = img.src;
            el.classList.add('is-decupat');
          };
          img.src = imagineMica(src, 600);
        }).catch(function () {});
      });
    }
    fetch(slide.getAttribute('data-api'), { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
      var praguri = c && c.activ && Array.isArray(c.praguri) ? c.praguri.filter(function (p) { return p.produse && p.produse.length; }).sort(function (a, b) { return a.prag - b.prag; }) : [];
      if (!praguri.length) { scoate(false); return; }
      praguri = praguri.slice(0, 3);
      dr.innerHTML = praguri.map(function (p, i) {
        var nume = p.produse.map(function (x) { return esc(x.titlu); });
        var text = nume.length > 1 ? nume.slice(0, -1).join(', ') + ' sau ' + nume[nume.length - 1] : nume[0];
        return '<span class="ce-cb__card ce-cb__card--' + (i + 1) + '">' +
          '<span class="ce-cb__card-text">' +
            '<span class="ce-cb__peste">Comenzi de la</span>' +
            '<span class="ce-cb__suma">' + suma(p.prag) + '<small>lei</small></span>' +
            '<span class="ce-cb__primesti">' + (p.produse.length > 1 ? 'Cadou la alegere' : 'Primești cadou') + '</span>' +
            '<span class="ce-cb__produs">' + text + '</span>' +
          '</span>' + SAGEATA_CB +
          '<span class="ce-cb__poze ce-cb__poze--' + Math.min(2, p.produse.length) + '">' + p.produse.slice(0, 2).map(poza).join('') + '</span>' +
        '</span>';
      }).join('');
      cutie.setAttribute('data-numar', praguri.length);
      cutie.classList.remove('is-incarca');
      // textul pentru cititoarele de ecran
      cutie.setAttribute('aria-label', (slide.querySelector('.ce-cb__t1') || {}).textContent + ' ' + (slide.querySelector('.ce-cb__t2') || {}).textContent + ' ' +
        praguri.map(function (p) { return 'La comenzi de la ' + suma(p.prag) + ' lei: ' + p.produse.map(function (x) { return x.titlu; }).join(' sau '); }).join('. '));
      cautaDecupate();
    }).catch(function () { scoate(true); });
  }

  // ---------- textul despre noi: „Citește tot” ----------
  function pregatesteDespre(s) {
    var corp = s.querySelector('[data-ce-despre-corp]');
    var buton = s.querySelector('[data-ce-despre-buton]');
    if (!corp || !buton) return;
    // textul stă închis de tot: se vede doar titlul și butonul (textul rămâne în pagină pentru Google)
    if (!corp.textContent.trim()) { s.classList.add('is-scurt'); return; }
    buton.hidden = false;
    buton.addEventListener('click', function () {
      var deschis = !s.classList.contains('is-deschis');
      s.classList.toggle('is-deschis', deschis);
      buton.setAttribute('aria-expanded', String(deschis));
      buton.querySelector('[data-inchis]').hidden = deschis;
      buton.querySelector('[data-deschis]').hidden = !deschis;
      if (!deschis) s.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
  }

  // ---------- inimioara de favorite din carduri (lista temei, păstrată în browser) ----------
  var ICON_ADAUGAT = '<svg class="t4s-svg-wis is-ic--added" viewBox="0 0 24 24" aria-hidden="true"><use xlink:href="#t4s-icon-wis-added"></use></svg>';
  function marcheazaFavorite(radacina) {
    var lista = '';
    try { lista = localStorage.getItem('t4s_wis') || ''; } catch (e) { return; }
    if (!lista) return;
    var ids = lista.split(',').map(function (x) { return x.replace('id:', ''); });
    (radacina || document).querySelectorAll('.ce-card__inima[data-id]:not(.is--added)').forEach(function (a) {
      if (ids.indexOf(a.getAttribute('data-id')) < 0) return;
      a.classList.add('is--added');
      var ic = a.querySelector('.t4s-svg-pr-icon');
      if (ic) ic.innerHTML = ICON_ADAUGAT;
      var tx = a.querySelector('.t4s-text-pr');
      if (tx && window.T4SProductStrings) tx.textContent = T4SProductStrings.remove_wishlist || tx.textContent;
    });
  }
  window.ceMarcheazaFavorite = marcheazaFavorite;
  // pe pagina de favorite, cardul scos din listă dispare (tema scoate doar cardurile ei)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ce-card__inima.is--added');
    if (!a || typeof window.isPageWishlist !== 'boolean') return;
    var col = a.closest('.ce-card-col');
    setTimeout(function () { if (col && !a.classList.contains('is--added')) col.remove(); }, 80);
  }, true);

  // ---------- meniul rapid: categoria curentă se vede pe telefon ----------
  function pregatesteRapid() {
    // prima pagină fără bannere: meniul rămâne sub antet
    var asteapta = document.querySelector('.ce-rapid--asteapta');
    if (asteapta) asteapta.classList.remove('ce-rapid--asteapta');
    var l = document.querySelector('[data-ce-rapid]');
    if (!l) return;
    var rama = l.closest('[data-ce-rapid-rama]');
    var st = rama && rama.querySelector('[data-ce-rapid-st]');
    var dr = rama && rama.querySelector('[data-ce-rapid-dr]');
    var a = l.querySelector('[aria-current="page"]');
    if (a && l.scrollWidth > l.clientWidth) { l.style.scrollBehavior = 'auto'; l.scrollLeft = Math.max(0, a.parentNode.offsetLeft - 16); l.style.scrollBehavior = ''; }
    if (!rama || !st || !dr) return;
    // săgețile: câte o categorie spre stânga / dreapta; apar doar când butoanele nu încap
    function elemente() { return Array.prototype.slice.call(l.children); }
    function stanga(li) { return li.offsetLeft; } // lista e position:relative, deci offsetLeft e față de începutul listei
    function stare() {
      var max = l.scrollWidth - l.clientWidth;
      var depaseste = max > 2;
      st.hidden = dr.hidden = !depaseste;
      st.disabled = l.scrollLeft <= 2;
      dr.disabled = l.scrollLeft >= max - 2;
      rama.classList.toggle('is-st', depaseste && !st.disabled);
      rama.classList.toggle('is-dr', depaseste && !dr.disabled);
    }
    function muta(sens) {
      var x = l.scrollLeft, tinta = null, lista = elemente();
      if (sens > 0) {
        // prima categorie care începe după marginea din stânga (cu o toleranță pentru umbra de la margine)
        for (var i = 0; i < lista.length; i++) { if (stanga(lista[i]) > x + 4) { tinta = stanga(lista[i]); break; } }
      } else {
        for (var j = lista.length - 1; j >= 0; j--) { if (stanga(lista[j]) < x - 4) { tinta = stanga(lista[j]); break; } }
        if (tinta === null) tinta = 0;
      }
      if (tinta === null) return;
      l.scrollTo({ left: Math.max(0, tinta - 2), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    st.addEventListener('click', function () { muta(-1); });
    dr.addEventListener('click', function () { muta(1); });
    var asteapta = null;
    l.addEventListener('scroll', function () { if (asteapta) return; asteapta = requestAnimationFrame(function () { asteapta = null; stare(); }); }, { passive: true });
    window.addEventListener('resize', stare);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(stare);
    stare();
  }

  // ---------- iconițele plutitoare ale aplicațiilor (Cookiebot, Alpha Loyalty) ----------
  function pregatestePlutitoare() {
    // „Setări cookie-uri” din subsol redeschide fereastra Cookiebot (iconița lor rotundă e ascunsă din CSS)
    var link = document.querySelector('[data-ce-cookie]');
    function cookiebot() {
      if (link && window.Cookiebot && typeof window.Cookiebot.renew === 'function') link.hidden = false;
    }
    if (link) {
      link.addEventListener('click', function () { if (window.Cookiebot && window.Cookiebot.renew) window.Cookiebot.renew(); });
      cookiebot();
      window.addEventListener('CookiebotOnLoad', cookiebot);
      window.addEventListener('load', cookiebot);
    }
    // lansatorul aplicației de fidelitate (și orice alt buton rotund al unei aplicații lipit în stânga ecranului):
    // element fix, mic, care nu e al temei
    var RE = /alpha|loyal/i;
    var AL_TEMEI = /(^|\s)(t4s-|ce-)|CybotCookiebot|CookiebotWidget/;
    function nume(e) { return (e.id || '') + ' ' + (typeof e.className === 'string' ? e.className : ''); }
    function cauta() {
      var gasit = false;
      function verifica(e, adancime) {
        if (!e || e.nodeType !== 1 || adancime > 5) return;
        if (/^(SCRIPT|STYLE|LINK|META|NOSCRIPT|TEMPLATE|SVG)$/i.test(e.tagName)) return;
        if (e.id === 'MainContent' || e.tagName === 'HEADER' || e.tagName === 'FOOTER' || e.classList.contains('t4s-website-wrapper') || e.classList.contains('shopify-section')) return;
        if (e.classList.contains('ce-plutitor-loialitate')) { gasit = true; return; }
        var cs = getComputedStyle(e);
        if (cs.position === 'fixed' && cs.display !== 'none') {
          var r = e.getBoundingClientRect();
          var mic = r.width > 24 && r.width <= 120 && r.height > 24 && r.height <= 120;
          var deAplicatie = RE.test(nume(e)) || (e.parentElement && RE.test(nume(e.parentElement)));
          var inStanga = r.left <= 60 && !AL_TEMEI.test(nume(e)) && !(e.parentElement && AL_TEMEI.test(nume(e.parentElement)));
          if (mic && (deAplicatie || inStanga)) { e.classList.add('ce-plutitor-loialitate'); gasit = true; return; }
        }
        for (var i = 0; i < e.children.length; i++) verifica(e.children[i], adancime + 1);
      }
      for (var i = 0; i < document.body.children.length; i++) verifica(document.body.children[i], 0);
      return gasit;
    }
    // aplicațiile își pun butonul după încărcare: căutăm la fiecare element nou adăugat în pagină, timp de 30 de secunde
    cauta();
    if ('MutationObserver' in window) {
      var t = null;
      var obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(cauta, 250); });
      obs.observe(document.body, { childList: true, subtree: false });
      setTimeout(function () { obs.disconnect(); }, 30000);
    }
    [1000, 3000, 6000, 12000].forEach(function (ms) { setTimeout(cauta, ms); });
  }

  // ---------- diacriticele „descompuse” ----------
  // Unele texte din magazin (titluri, descrieri copiate de pe Mac) au „ă” scris ca „a” + semn separat (U+0306).
  // Fonturile site-ului nu au semnul separat, așa că litera apărea cu alt font. Le compunem la loc (NFC):
  // textul rămâne identic, doar se afișează corect. Nu se schimbă nimic în magazin.
  var SEMNE = /[\u0300-\u036f]/;
  function compuneText(n) {
    // doar dacă se schimbă ceva (altfel observatorul s-ar reapela la nesfârșit)
    var v = n.nodeValue, c = v.normalize('NFC');
    if (c !== v) n.nodeValue = c;
  }
  function compuneDiacritice(radacina) {
    if (!radacina || !String.prototype.normalize) return;
    if (radacina.nodeType === 3) { compuneText(radacina); return; }
    if (radacina.nodeType !== 1 || !SEMNE.test(radacina.textContent || '')) return;
    var w = document.createTreeWalker(radacina, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        return SEMNE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var lista = [], n;
    while ((n = w.nextNode())) lista.push(n);
    lista.forEach(compuneText);
  }
  function urmaresteDiacritice() {
    compuneDiacritice(document.body);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (schimbari) {
      schimbari.forEach(function (s) {
        if (s.type === 'characterData') { if (SEMNE.test(s.target.nodeValue)) compuneDiacritice(s.target); return; }
        for (var i = 0; i < s.addedNodes.length; i++) compuneDiacritice(s.addedNodes[i]);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // ---------- bara de sus: numărătoarea ca în coș + data pentru Ilfov ----------
  function pregatesteBaraSus() {
    var b = document.querySelector('[data-ce-bara-sus]');
    if (!b) return;
    var ORA = b.getAttribute('data-ora') || '13:00';
    var ILFOV = (b.getAttribute('data-ilfov') || '11:00-13:30').replace(/\s/g, '');
    var azEl = b.querySelector('[data-ce-sus-azi]'), azTx = b.querySelector('[data-ce-sus-azi-text]');
    var ilEl = b.querySelector('[data-ce-sus-ilfov]'), ilTx = b.querySelector('[data-ce-sus-ilfov-text]');
    var limita = null, primaZi = null, ziIlfov = null, intIlfov = ILFOV;
    function ziRo(d) { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Bucharest' }).format(d || new Date()); }
    function decalaj() {
      // ora României (+02:00 iarna, +03:00 vara), ca în coș
      var fus = (new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Bucharest', timeZoneName: 'shortOffset' }).formatToParts(new Date())
        .filter(function (x) { return x.type === 'timeZoneName'; })[0] || {}).value || 'GMT+2';
      var m = /GMT([+-])(\d{1,2})/.exec(fus);
      return m ? m[1] + ('0' + m[2]).slice(-2) + ':00' : '+02:00';
    }
    function eticheta(data) { return new Date(data + 'T12:00:00Z').toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Europe/Bucharest' }); }
    function adaugaZile(data, n) { var d = new Date(data + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }
    function duminica(data) { return new Date(data + 'T12:00:00Z').getUTCDay() === 0; }
    function interval(t) { return t.replace('-', '–'); }
    function bate() {
      var ramas = limita ? limita - Date.now() : 0;
      if (ramas > 60000 && ramas < 14 * 3600e3) {
        var min = Math.floor(ramas / 60000);
        var text = min >= 60 ? Math.floor(min / 60) + ' h ' + (min % 60) + ' min' : min + ' min';
        azTx.innerHTML = 'Comandă în <b>' + text + '</b> și poate ajunge <b>azi</b> în București';
        azEl.classList.remove('is-mai-tarziu'); azEl.hidden = false;
      } else if (primaZi && primaZi !== ziRo()) {
        azTx.innerHTML = 'Cel mai devreme livrăm <b>' + esc(eticheta(primaZi)) + '</b>';
        azEl.classList.add('is-mai-tarziu'); azEl.hidden = false;
      } else if (limita && ramas <= 60000) {
        // a trecut ora: recalculează din program
        limita = null; incarca(); return;
      } else azEl.hidden = true;
      if (ziIlfov) {
        ilTx.innerHTML = '<b>Ilfov</b>: livrare <b>' + esc(eticheta(ziIlfov)) + '</b>, ' + esc(interval(intIlfov));
        ilEl.hidden = false;
      } else ilEl.hidden = true;
    }
    function local() {
      // fără program din admin: aceeași regulă ca bara veche (13:00, fără duminică)
      var azi = ziRo();
      var lim = Date.parse(azi + 'T' + ORA + ':00' + decalaj());
      limita = !duminica(azi) && Date.now() < lim ? lim : null;
      var z = limita ? azi : adaugaZile(azi, 1);
      while (duminica(z)) z = adaugaZile(z, 1);
      primaZi = z;
      var zi = adaugaZile(azi, 1);
      while (duminica(zi)) zi = adaugaZile(zi, 1);
      ziIlfov = zi; intIlfov = ILFOV;
    }
    function incarca() {
      json(API + '/api/disponibilitate?produse=').then(function (d) {
        var azi = ziRo();
        var zile = (d && d.zile) || [];
        var deschis = function (z) { return (z.intervale || []).some(function (x) { return x.deschis; }); };
        var z0 = zile[0];
        limita = z0 && z0.data === azi && deschis(z0) ? Date.parse(azi + 'T' + ORA + ':00' + decalaj()) : null;
        var p = zile.filter(deschis)[0];
        primaZi = p ? p.data : null;
        ziIlfov = null; intIlfov = ILFOV;
        for (var i = 0; i < zile.length && !ziIlfov; i++) {
          if (zile[i].data <= azi) continue;
          var x = (zile[i].intervale || []).filter(function (y) { return y.deschis && (y.start + '-' + y.sfarsit) === ILFOV; })[0];
          if (x) { ziIlfov = zile[i].data; intIlfov = x.start + '-' + x.sfarsit; }
        }
        if (!ziIlfov) { var urm = zile.filter(function (z) { return z.data > azi && deschis(z); })[0]; if (urm) ziIlfov = urm.data; }
        if (!primaZi && !ziIlfov) local();
        bate();
      }).catch(function () { local(); bate(); });
    }
    incarca();
    setInterval(bate, 30000);
  }

  // ---------- bara de jos (telefon) și butonul „sus” ----------
  function pregatesteDock() {
    var dock = document.querySelector('.t4s-toolbar');
    var sus = document.getElementById('t4s-backToTop');
    var html = document.documentElement;
    // butonul paginii curente
    if (dock) {
      var cale = location.pathname.replace(/\/$/, '') || '/';
      dock.querySelectorAll('.t4s-toolbar-item > a').forEach(function (a) {
        var u = new URL(a.getAttribute('href') || '#', location.href);
        var c = u.pathname.replace(/\/$/, '') || '/';
        var potrivit = c === cale && (u.search === '' || location.search.indexOf(u.search.slice(1)) >= 0);
        if (potrivit && c !== '/') a.setAttribute('aria-current', 'page');
      });
      // numărul din coș / favorite „sare” când se schimbă
      if ('MutationObserver' in window) {
        dock.querySelectorAll('.t4s-count-box').forEach(function (b) {
          var vechi = b.textContent;
          b.classList.toggle('ce-zero', b.textContent.trim() === '0');
          new MutationObserver(function () {
            b.classList.toggle('ce-zero', b.textContent.trim() === '0');
            if (b.textContent === vechi) return;
            vechi = b.textContent;
            b.classList.remove('ce-pop'); void b.offsetWidth; b.classList.add('ce-pop');
          }).observe(b, { childList: true, characterData: true, subtree: true });
        });
      }
    }
    // se ascunde când derulezi în jos și revine când urci (sau aproape de capăt)
    var ultim = window.scrollY, ascuns = false, programat = false;
    function laDerulare() {
      programat = false;
      var y = window.scrollY, max = document.documentElement.scrollHeight - window.innerHeight;
      if (sus) sus.style.setProperty('--ce-progres', max > 0 ? Math.min(1, y / max).toFixed(3) : 0);
      if (!dock) return;
      var jos = y > ultim + 6, susDir = y < ultim - 6;
      var deAscuns = ascuns;
      if (jos && y > 160) deAscuns = true;
      if (susDir || y < 120 || y > max - 80) deAscuns = false;
      if (document.querySelector('.t4s-drawer.is--opend, .ce-foaie.is-deschis')) deAscuns = false;
      if (deAscuns !== ascuns) { ascuns = deAscuns; html.classList.toggle('ce-dock-ascuns', ascuns); }
      if (jos || susDir) ultim = y;
    }
    window.addEventListener('scroll', function () { if (!programat) { programat = true; requestAnimationFrame(laDerulare); } }, { passive: true });
    laDerulare();
  }

  function porneste() {
    var f = document.querySelector('[data-ce-format-bani]');
    formatBani = f ? f.getAttribute('data-ce-format-bani') : null;
    masoaraAntet();
    var h = document.querySelector('.t4s-section-header');
    if (h && 'ResizeObserver' in window) new ResizeObserver(masoaraAntet).observe(h);
    window.addEventListener('scroll', function () { requestAnimationFrame(masoaraAntet); }, { passive: true });
    document.querySelectorAll('[data-ce-raft]').forEach(pregatesteRaft);
    // banda roșie cu promoția primește fontul nou doar pe prima pagină
    if (document.querySelector('[data-ce-index]')) {
      document.querySelectorAll('.t4s-prt-text').forEach(function (p) { var s = p.closest('.shopify-section'); if (s) s.classList.add('ce-acasa-banda'); });
    }
    pregatesteIndex();
    document.querySelectorAll('[data-ce-erou]').forEach(pregatesteErou);
    document.querySelectorAll('[data-ce-erou-cadou]').forEach(pregatesteCadouBanner);
    document.querySelectorAll('[data-ce-despre]').forEach(pregatesteDespre);
    urmaresteDiacritice();
    pregatestePlutitoare();
    pregatesteRapid();
    pregatesteBaraSus();
    pregatesteDock();
    marcheazaFavorite();
    // cardurile încărcate mai târziu (derulare infinită, filtre) primesc și ele starea inimioarei
    if ('MutationObserver' in window) {
      var tmp = null;
      new MutationObserver(function () { clearTimeout(tmp); tmp = setTimeout(function () { marcheazaFavorite(); }, 120); })
        .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste); else porneste();
})();
